import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCheckDouble = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10.336 11.443c-.304.36-.847.36-1.183 0L6.295 8.615c-.335-.3-.335-.838 0-1.17a.87.87 0 0 1 1.213 0l2.252 2.23 5.11-5.056c.336-.332.88-.332 1.183 0a.795.795 0 0 1 0 1.2zm0 7.917c-.304.36-.847.36-1.183 0l-4.859-4.807c-.335-.3-.335-.838 0-1.17a.87.87 0 0 1 1.213 0l4.253 4.21 8.827-8.734c.336-.329.879-.329 1.183 0 .364.332.364.87 0 1.17z"
    }));
export default SvgCheckDouble;
